import { Component, OnInit } from "@angular/core";
import { MetaService } from "../meta.service";

@Component({
	selector: "app-energy-utilities",
	templateUrl: "./energy-utilities.component.html",
	styleUrls: ["./energy-utilities.component.css"],
})
export class EnergyUtilitiesComponent implements OnInit {
	constructor(private mds: MetaService) {}

	ngOnInit(): void {
		//SEO Optimization
		var strTitle = "RegScale - Energy & Utilities";
		var description = "RegScale solutions for Energy & Utilities";
		var keywords = "RegScale, Energy & Utilities ";
		this.mds.updateTags(strTitle, keywords, description);
	}
}
